<div class="settings settings-content">
  <content-title-v2 [title]="'Settings.User.titleV2' | translate" />

  <div class="settings-content-section-forms">
    <user-base-data [form]="form" />
    <user-password class="d-block mt-4" [disabled]="!(storage.UserPerson.registrationMethod !== 'google')" />
    <user-mcp-connection *appHasRole="mcpRoles" class="d-block mt-4" />
  </div>
</div>
